var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProPill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40,
    height: 18.2191,
    viewBox: "0 0 40 18.2191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Inner",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8907 0.684837C35.5435 0.684837 39.3153 4.4567 39.3153 9.10952C39.3153 13.7623 35.5435 17.5342 30.8907 17.5342H9.10977C4.45695 17.5342 0.685091 13.7623 0.685091 9.10952C0.685091 4.4567 4.45695 0.684837 9.10977 0.684837H30.8907Z",
    fill: "url(#paint0_linear_791_19995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    d: "M30.8904 0C35.9215 2.09611e-06 40 4.07846 40 9.10956C40 14.1407 35.9215 18.2191 30.8904 18.2191H9.10956C4.07846 18.2191 0 14.1407 0 9.10956C1.57208e-06 4.07846 4.07846 1.04792e-06 9.10956 0H30.8904ZM9.10956 0.68488C4.45674 0.684881 0.684881 4.45674 0.68488 9.10956C0.68488 13.7624 4.45674 17.5342 9.10956 17.5342H30.8904C35.5433 17.5342 39.3151 13.7624 39.3151 9.10956C39.3151 4.45674 35.5433 0.684882 30.8904 0.68488H9.10956Z",
    fill: "url(#paint1_linear_791_19995)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Gloss",
    x: 1.37018,
    y: 1.3698,
    width: 37.2604,
    height: 15.4795,
    rx: 7.73975,
    fill: "url(#paint2_linear_791_19995)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 27",
    filter: "url(#filter0_d_791_19995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.6122 13.6685C28.946 13.6685 28.3382 13.5603 27.7886 13.3438C27.239 13.1273 26.7644 12.8192 26.3647 12.4195C25.9734 12.0115 25.6694 11.5285 25.4529 10.9706C25.2448 10.4127 25.1407 9.79655 25.1407 9.12208C25.1407 8.43928 25.2448 7.81894 25.4529 7.26104C25.6694 6.70314 25.9734 6.22435 26.3647 5.82467C26.7644 5.42498 27.239 5.12105 27.7886 4.91288C28.3382 4.69638 28.946 4.58813 29.6122 4.58813C30.2783 4.58813 30.8862 4.69638 31.4358 4.91288C31.9853 5.12105 32.4558 5.42498 32.8471 5.82467C33.2468 6.22435 33.5508 6.70314 33.7589 7.26104C33.9754 7.81061 34.0837 8.42679 34.0837 9.10959C34.0837 9.80072 33.9754 10.4252 33.7589 10.9831C33.5508 11.541 33.2468 12.024 32.8471 12.432C32.4558 12.8317 31.9853 13.1398 31.4358 13.3563C30.8862 13.5644 30.2783 13.6685 29.6122 13.6685ZM29.6122 11.745C30.0535 11.745 30.4282 11.6409 30.7363 11.4328C31.0444 11.2246 31.2817 10.9248 31.4482 10.5335C31.6148 10.1421 31.698 9.67165 31.698 9.12208C31.698 8.57251 31.6148 8.10205 31.4482 7.71069C31.29 7.31933 31.0527 7.02373 30.7363 6.82388C30.4282 6.61571 30.0535 6.51163 29.6122 6.51163C29.1792 6.51163 28.8045 6.61571 28.4881 6.82388C28.18 7.02373 27.9427 7.31933 27.7761 7.71069C27.6096 8.10205 27.5263 8.57251 27.5263 9.12208C27.5263 9.67165 27.6054 10.1421 27.7636 10.5335C27.9302 10.9248 28.1716 11.2246 28.4881 11.4328C28.8045 11.6409 29.1792 11.745 29.6122 11.745Z",
    fill: "url(#paint3_linear_791_19995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8677 13.5312C16.724 13.5312 16.6075 13.4147 16.6075 13.271V4.98582C16.6075 4.84211 16.724 4.72561 16.8677 4.72561H20.8417C21.8409 4.72561 22.6112 4.97125 23.1524 5.46253C23.702 5.94549 23.9768 6.61996 23.9768 7.48595C23.9768 8.04384 23.8519 8.53096 23.6021 8.9473C23.3606 9.35532 23.0067 9.67173 22.5404 9.89656C22.0824 10.1131 21.5162 10.2213 20.8417 10.2213L20.9416 9.99648H21.5412C21.8992 9.99648 22.2156 10.0839 22.4904 10.2588C22.7652 10.4253 22.9942 10.6834 23.1774 11.0332L24.3392 13.1456C24.4346 13.319 24.3091 13.5312 24.1112 13.5312H22.1829C22.0876 13.5312 21.9999 13.4791 21.9544 13.3955L20.5045 10.7334C20.4379 10.6085 20.3588 10.5127 20.2672 10.4461C20.1756 10.3795 20.0715 10.3296 19.9549 10.2962C19.8467 10.2629 19.7259 10.2463 19.5927 10.2463H19.1659C19.0222 10.2463 18.9057 10.3628 18.9057 10.5065V13.271C18.9057 13.4147 18.7892 13.5312 18.6455 13.5312H16.8677ZM18.9057 8.36234C18.9057 8.50606 19.0222 8.62256 19.1659 8.62256H20.4295C20.8709 8.62256 21.2081 8.53513 21.4412 8.36026C21.6744 8.1854 21.791 7.91478 21.791 7.5484C21.791 7.19867 21.6744 6.93638 21.4412 6.76151C21.2081 6.57833 20.8709 6.48673 20.4295 6.48673H19.1659C19.0222 6.48673 18.9057 6.60323 18.9057 6.74694V8.36234Z",
    fill: "url(#paint4_linear_791_19995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.42709 13.5312C8.28338 13.5312 8.16688 13.4147 8.16688 13.271V4.98582C8.16688 4.84211 8.28338 4.72561 8.42709 4.72561H12.4011C13.0672 4.72561 13.6334 4.84219 14.0997 5.07534C14.566 5.30016 14.9199 5.62907 15.1614 6.06206C15.4112 6.48673 15.5361 7.00299 15.5361 7.61085C15.5361 8.20205 15.4112 8.71832 15.1614 9.15964C14.9199 9.59263 14.566 9.9257 14.0997 10.1589C13.6334 10.3837 13.0672 10.4961 12.4011 10.4961H10.7253C10.5816 10.4961 10.4651 10.6126 10.4651 10.7563V13.271C10.4651 13.4147 10.3486 13.5312 10.2049 13.5312H8.42709ZM10.4651 8.47476C10.4651 8.61847 10.5816 8.73497 10.7253 8.73497H12.0014C12.4344 8.73497 12.7674 8.64337 13.0006 8.46018C13.2337 8.26867 13.3503 7.98556 13.3503 7.61085C13.3503 7.22782 13.2337 6.9447 13.0006 6.76151C12.7674 6.57833 12.4344 6.48673 12.0014 6.48673H10.7253C10.5816 6.48673 10.4651 6.60323 10.4651 6.74694V8.47476Z",
    fill: "url(#paint5_linear_791_19995)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_791_19995",
    x: 8.16688,
    y: 4.58813,
    width: 25.9168,
    height: 9.3406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.260213
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_791_19995"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_791_19995",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_791_19995",
    x1: 20.0002,
    y1: 0.684837,
    x2: 20.0002,
    y2: 17.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6D6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_791_19995",
    x1: 20,
    y1: 0.68488,
    x2: 20,
    y2: 17.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBB9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_791_19995",
    x1: 19.8382,
    y1: 1.3698,
    x2: 19.8382,
    y2: 16.8493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAB8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_791_19995",
    x1: 29.6122,
    y1: 13.6685,
    x2: 29.6122,
    y2: 4.58813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_791_19995",
    x1: 20.5794,
    y1: 13.5312,
    x2: 20.5794,
    y2: 4.72561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_791_19995",
    x1: 11.8515,
    y1: 13.5312,
    x2: 11.8515,
    y2: 4.72561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProPill);
export default __webpack_public_path__ + "static/media/pro_pill.04df0f6901a4c8f5914035875ff9229a.svg";
export { ForwardRef as ReactComponent };